import { selector, selectorFamily } from 'recoil';
import { httpGet } from 'modules/api';

export const languagesSelector = selector({
    key: 'Languages',
    get: async () => {
        try {
            const response = await httpGet('/languages');
            return (response && response.languages) || [];
        } catch {
            return [];
        }
    },
});

export const languageNameByCodeSelector = selectorFamily({
    key: 'LanguageNameByCode',
    get: (language) => ({ get }) => {
        const languages = get(languagesSelector);
        const matchedLanguage = languages.find(({ code }) => code === language);
        return matchedLanguage ? matchedLanguage.name : 'English';
    },
});
